import { Box, Typography } from "@mui/material";
import React from "react";
import condidate from "../../images/joined-condidate.png";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import TurnedInNotIcon from "@mui/icons-material/TurnedInNot";

export default function CandidateCard({ candidate }) {
  return (
    <>
      {
        candidate != undefined
          ?
          <Box className="candidate-cardBox">
            <Box>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  position: 'relative'
                }}
              >
                <Box textAlign={'center'}>
                  <Box sx={{ marginTop: "-30px", }}>
                    <img src={candidate.avatar} alt="img" style={{ height: '70px', width: '70px', borderRadius: '6px' }} />
                  </Box>

                  <Typography
                    sx={{
                      fontFamily: "Inter",
                      fontWeight: 600,
                      fontSize: "12px",
                      lineHeight: "21px",
                      color: "#000000",
                      mt: 1,
                    }}
                  >
                    {candidate.fullName}
                  </Typography>
                  <Typography
                    sx={{
                      fontFamily: "Inter",
                      fontWeight: 600,
                      fontSize: "9px",
                      lineHeight: "21px",
                      color: "#000000",
                      opacity: 0.5,
                    }}
                    dangerouslySetInnerHTML={{__html: candidate?.description}}
                  >
                  </Typography>
                </Box>
                <Box sx={{ position: 'absolute', top: 8, right: 8 }} ><TurnedInNotIcon /></Box>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  p: 1,
                  background:
                    "linear-gradient(270deg, #F2F4FB 0%, #EFF2FA 25.93%, #E8EDF9 67.2%, #C8D8F1 100%)",
                  borderRadius: "0px 0px 12.4741px 12.4741px",
                  mt: 3,
                }}
              >
                <Typography
                  sx={{
                    fontFamily: "Inter",
                    fontWeight: 500,
                    fontSize: "9px",
                    lineHeight: "21px",
                    textAlign: "center",
                    color: "#000000",
                    opacity: 0.5,
                  }}
                >
                  <LocationOnIcon sx={{ fontSize: "12px" }} />
                  {candidate?.address}
                </Typography>
                <Typography
                  sx={{
                    fontFamily: "Inter",
                    fontWeight: 500,
                    fontSize: "12px",
                    lineHeight: "21px",
                    color: "#2544EE",
                  }}
                >
                  View Profile <NavigateNextIcon />
                </Typography>
              </Box>
            </Box>
          </Box>
          :
          <Box className="candidate-cardBox">
            <Box>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  position: 'relative'
                }}
              >
                <Box textAlign={'center'}>
                  <Box sx={{ marginTop: "-30px", }}>
                    <img src={condidate} alt="img" style={{ height: '70px', width: '70px', borderRadius: '6px' }} />
                  </Box>

                  <Typography
                    sx={{
                      fontFamily: "Inter",
                      fontWeight: 600,
                      fontSize: "12px",
                      lineHeight: "21px",
                      color: "#000000",
                      mt: 1,
                    }}
                  >
                    Wanda Montgomery
                  </Typography>
                  <Typography
                    sx={{
                      fontFamily: "Inter",
                      fontWeight: 600,
                      fontSize: "9px",
                      lineHeight: "21px",
                      color: "#000000",
                      opacity: 0.5,
                    }}
                  >
                    Charted Accountant | 4 Years Experience
                  </Typography>
                </Box>
                <Box sx={{ position: 'absolute', top: 8, right: 8 }} ><TurnedInNotIcon /></Box>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  p: 1,
                  background:
                    "linear-gradient(270deg, #F2F4FB 0%, #EFF2FA 25.93%, #E8EDF9 67.2%, #C8D8F1 100%)",
                  borderRadius: "0px 0px 12.4741px 12.4741px",
                  mt: 3,
                }}
              >
                <Typography
                  sx={{
                    fontFamily: "Inter",
                    fontWeight: 500,
                    fontSize: "9px",
                    lineHeight: "21px",
                    textAlign: "center",
                    color: "#000000",
                    opacity: 0.5,
                  }}
                >
                  <LocationOnIcon sx={{ fontSize: "12px" }} />
                  Gurugram, Haryana
                </Typography>
                <Typography
                  sx={{
                    fontFamily: "Inter",
                    fontWeight: 500,
                    fontSize: "12px",
                    lineHeight: "21px",
                    color: "#2544EE",
                  }}
                >
                  View Profile <NavigateNextIcon />
                </Typography>
              </Box>
            </Box>
          </Box>
      }
    </>
  );
}
